/**
 * Utility functions for unit conversion
 */

// Conversion constants
const METER_TO_INCH = 39.3701; // 1 meter = 39.3701 inches

// Countries that use imperial units (inches, feet, etc.)
const IMPERIAL_COUNTRIES = [
    'US', // United States
    'LR', // Liberia
    'MM', // Myanmar
    'GB', // United Kingdom (mixed, but often imperial for some measurements)
    'CA', // Canada (mixed, but often imperial for some measurements)
];

/**
 * Determine the unit system based on country code
 * @param countryCode - ISO 3166-1 alpha-2 country code
 * @returns 'inch' for imperial countries, 'cm' for metric countries
 */
export function getUnitSystemByCountry(countryCode?: string): 'cm' | 'inch' {
    if (!countryCode) {
        return 'cm'; // Default to metric
    }
    
    return IMPERIAL_COUNTRIES.includes(countryCode.toUpperCase()) ? 'inch' : 'cm';
}

/**
 * Convert meters to inches
 * @param meters - value in meters
 * @returns value in inches
 */
export function meterToInch(meters: number): number {
    return meters * METER_TO_INCH;
}



/**
 * Convert and format measurement from meters to inch (one decimal place)
 * @param meters - value in meters
 * @returns formatted string in inches (one decimal place)
 */
export function formatMeterToInch(meters: number): string {
    const inches = meterToInch(meters);
    return `${inches.toFixed(1)} in.`;
}

